import styled, { css } from "styled-components";
import { COLORS } from "../../../../shared/consts";
import { toRem } from "shared/helpers";

export const ListWrap = styled.div<{ $isWidget?: boolean }>`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: ${toRem(10)};
  }

  ${({ $isWidget }) =>
    $isWidget &&
    css`
      display: flex;
      flex-direction: column;
      gap: ${toRem(10)};
    `}
`;
export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  background: ${COLORS.BG.SURFACE2};
  border-radius: ${toRem(16)};
  padding: ${toRem(16)};
  color: ${COLORS.FG.DEFAULT};
`;

export const Right = styled.div`
  display: flex;
  gap: ${toRem(28)};
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
`;

export const DateRow = styled.div`
  font-size: ${toRem(12)};
  color: ${COLORS.FG.MUTED};
`;

export const TitleRow = styled.div`
  font-size: ${toRem(14)};
  font-weight: 400;
`;

export const IconRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    width: ${toRem(24)};
    height: ${toRem(24)};
  }
`;

export const Periods = styled.div`
  display: flex;
  gap: ${toRem(8)};
  align-content: center;
`;

export const Period = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${toRem(2)};
  text-align: center;

  span {
    font-size: ${toRem(12)};
    color: ${COLORS.FG.MUTED};
  }
  b {
    font-size: ${toRem(14)};
    font-weight: 400;
  }
`;
